module.exports = 'DeviceOrientationEvent' in window && 'ontouchmove' in window;


// WEBPACK FOOTER //
// ./src/lib/isMobile.js